
if (!window.dAgency) window.dAgency = {};
window.dAgency.initProductTile = (tile) => {
  if (!tile) return;
};

if (document.readyState != "loading") {
  [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
    window.dAgency.initProductTile(tile);
  });
} else {
  document.addEventListener('DOMContentLoaded', () => {
    [].forEach.call(document.querySelectorAll('.product-tile__container'), (tile) => {
      window.dAgency.initProductTile(tile);
    });
  });
}
